export default __webpack_public_path__ + "static/media/ic-alarm-massage-read.79882207.svg";